import {Linq, ModalDialog, ScrollTable} from "../../ui";
import {DialogStore, fmsPackageDetailStore} from "../../../store";
import {observer} from "mobx-react";

const FmsPicklistDialog = observer(function FmsPicklistDialog({
                                                                  store
                                                              }: {
    store: DialogStore
}) {
    return <ModalDialog
        titleCloseable={true}
        store={store}
        actions={[]}
        title={"Picklisten Historie"}
    >
        <div style={{
            height: '10em',
            display: 'flex'
        }}>
            <ScrollTable>
                <thead>
                <tr>
                    <th>Id</th>
                    <th style={{
                        textAlign: 'right',
                        width: '7em'
                    }}>Elemente
                    </th>
                </tr>
                </thead>
                <tbody>
                {fmsPackageDetailStore.picklists.map(pl => {

                    return <tr key={pl.id}>
                        <td style={{display: 'flex'}}>
                            <span style={{ paddingRight: '1em' }}>{pl.id}</span>
                            <Linq
                                to={`/fms/picklist/${pl.id}`}><span
                                className="material-symbols-outlined has-text-link">link</span></Linq>
                        </td>
                        <td style={{textAlign: 'right'}}>{pl.itemCount}</td>
                    </tr>
                })}
                </tbody>
            </ScrollTable>
        </div>
    </ModalDialog>
})

export {
    FmsPicklistDialog
}
